export class PaymentConfig {
    accountId: String;
    created: String;
    createdBy: number;
    fundus: number=null;
    fundusAutonomous:number=null;
    id: number;
    lastUpdated: String;
    referral: number=null;
    teleRefraction:number=null;
    refraction: number=null;
    spectacleBasic: number=null;
    spectacleAdvanced: number=null;
    status: boolean;
  }